import { CbBankFieldTypes } from 'cbbank/inquiry/fields';

type CbBankBankAccountSectionFieldTypes =
  CbBankFieldTypes['personalDataPage']['bankAccountSection'];

export const mapCbBankBankAccount = (values: CbBankBankAccountSectionFieldTypes) => ({
  iban: values.iban,
});
